export { default as PortalHomeDumb } from './portal-home-dumb';
